<template>
    <div class="congress-schedule-day">
        <!-- Day Header: Date + Label -->
        <div class="congress-schedule-day-header">
            <!-- Date -->
            <div class="congress-schedule-day-header-date">
                <Field
                    v-model="day.date"
                    label-position="none"
                    :field="{
                        name: lang('congresses::congresses.schedule.date'),
                        slug: `schedule.${dayIndex}.date`,
                        type: 'date',
                        adminComponent: 'AdminDate',
                        required: true,
                    }"
                />
            </div>

            <!-- Date label -->
            <div class="congress-schedule-day-header-date-label">
                <Field
                    v-model="day.date_label"
                    label-position="none"
                    :field="{
                        name: lang('congresses::congresses.schedule.date_label'),
                        slug: `schedule.${dayIndex}.date_label`,
                        type: 'text',
                        adminComponent: 'AdminText',
                        required: true,
                    }"
                />
            </div>

            <!-- Remove button -->
            <div class="congress-schedule-day-header-actions">
                <Button type="button" size="sm" color="secondary" variant="inline" @click="$emit('remove')">
                    <span class="action-icon">
                        <Icon icon="phosphor/regular/trash"></Icon>
                    </span>
                    <span class="action-label">
                        {{ lang('congresses::congresses.schedule.remove_day') }}
                    </span>
                </Button>
            </div>
        </div>

        <!-- Events list -->
        <ScheduleEventList v-model="scheduleEvents" event-type="schedule" :day-index="dayIndex" />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { lang } from '@/lang/composable';
import Button from '@src/Common/Components/Button.vue';
import Field from '@src/Common/Components/Field.vue';
import ScheduleEventList from './ScheduleEventList.vue';
import type { ScheduleDay as ScheduleDayType } from '../types';

// eslint-disable-next-line
const props = defineProps<{
    dayIndex: number;
}>();

// eslint-disable-next-line
const emit = defineEmits<{
    (e: 'remove'): void;
}>();

const day = defineModel<ScheduleDayType>();

// Filter only schedule events (not program events)
const scheduleEvents = computed({
    get: () => {
        return (day.value?.events || []).filter((e) => e.type === 'schedule' || !e.type);
    },
    set: (newEvents) => {
        if (!day.value) return;
        // Keep program events, replace schedule events
        const programEvents = (day.value.events || []).filter((e) => e.type === 'program');
        day.value.events = [...newEvents, ...programEvents];
    },
});
</script>
